
$(function () {
	OverflowContainer.init();
});

$(document).on("mvvm:updated", function () {
	OverflowContainer.init();
});

/**
 * @namespace
 * @global
 */
const OverflowContainer = (function () {

	function init() {
		checkOverflow();

		$(".overflow-show-more button.show-less").on("click", function () {
			var parent = $(this).parents('.overflow-container');
			var description = parent.children('.overflow-content');
	
			parent.removeClass('expanded');
			description.css("height", "");
		});
	
		$(".overflow-show-more button.show-more").on("click", function () {
			var $parent = $(this).parents('.overflow-container');
			var $description = $parent.children('.overflow-content');
			
			$parent.addClass('expanded');
			$description.css("height", `calc(var(--button-top-margin) + ${$description[0].scrollHeight + $(this).outerHeight()}px)`);
			// console.log(`calc(--button-top-margin + ${$description[0].scrollHeight + $(this).outerHeight()}px)`);
			// $description[0].style.setProperty("height", `${$description[0].scrollHeight + $(this).outerHeight()}`);
		});
	}

	function checkOverflow() {
		$(".overflow-content").each(function () {
			if ($(this)[0].scrollHeight > Math.ceil($(this).innerHeight())) {
				$(this).parent('.overflow-container').addClass('overflowed');
			} else {
				$(this).parent('.overflow-container').removeClass('overflowed');
			}
		});
	}

	return {
		checkOverflow: checkOverflow,
		init: init,
	};

}());